import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logoutRequest } from '@Redux/actions/authentication';
import {
  setZenDeskActiveChat,
  toggleIsRevampApiCalled
} from '@Redux/actions/help-center-action/help-center-actions';
import { selectUserStatusReducer } from '@Redux/selectors';
import { INDIVIDUAL, POST_LOGOUT_URL } from '@Utils/constants';
import { logEventV2, getPageName } from '@Utils/events/logUserEvents';
import { EventButtonType, EventNamesV2, FLOW_TYPE } from '@Utils/events/eventsConstants';
import { AppDispatch } from '../store.type';

export const LOGOUT_LABEL = 'Logout';

export const useLogout = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { account_type } = useSelector(selectUserStatusReducer);

  const disableZendesk = useCallback(() => {
    const { zE: zenDesk } = window;
    if (zenDesk) {
      zenDesk('messenger', 'logoutUser');
      dispatch(setZenDeskActiveChat(false));
    }
  }, [dispatch]);

  const logout = useCallback(async () => {
    logEventV2(EventNamesV2.CTA_CLICKED, {
      type: EventButtonType.BUTTON,
      pageName: getPageName(),
      ctaName: LOGOUT_LABEL,
      flowType: FLOW_TYPE.LOGOUT
    });
    const response = await dispatch(logoutRequest());
    if (account_type === INDIVIDUAL && response?.data?.success) {
      disableZendesk();
      dispatch(toggleIsRevampApiCalled(false));
      navigate(POST_LOGOUT_URL);
    }
  }, [account_type, dispatch, disableZendesk, navigate]);

  return logout;
};
